import { render, staticRenderFns } from "./RequestNewFormat.vue?vue&type=template&id=29b933a6&scoped=true"
import script from "./RequestNewFormat.vue?vue&type=script&lang=js"
export * from "./RequestNewFormat.vue?vue&type=script&lang=js"
import style0 from "./RequestNewFormat.vue?vue&type=style&index=0&id=29b933a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b933a6",
  null
  
)

export default component.exports